import MerchantCard from './MerchantCard'

export default MerchantCard
